import moment from 'moment'
import {
    ACTIVITY_FILTERS,
    ARC_FILTERS,
    DATE_FILTERS,
    DURATION_FILTERS,
    ATTRIBUTES_FILTERS,
    VARIANT_FILTERS,
    LOOP_FILTERS,
    NVARIANTS_FILTERS,
    TRACES_FILTERS,
} from '@/screens/Project/Process/Filters/FilterModal/filtersEntity'
import { isFilterSet } from './isFilterSet'

function ensureArray(value) {
    if (value === undefined || value === null) return []
    return Array.isArray(value) ? value : [value]
}

function unwrapValue(maybe) {
    if (!maybe) return maybe
    if (typeof maybe === 'object' && Object.prototype.hasOwnProperty.call(maybe, 'value')) return maybe.value
    return maybe
}

function formatDateToBackend(raw) {
    if (!raw) return null
    if (typeof raw !== 'string') return raw
    const formattedInput = raw.replace(/\//g, '-')
    return moment(formattedInput).format('YYYY-MM-DDTHH:mm:ss')
}

export function serializeFilterForApi(filter = {}) {
    if (isFilterSet(filter)) return null

    const { id, kind } = filter
    const meta = filter.meta || {}
    const values = ensureArray(filter.values ?? filter.value ?? filter.key)

    // Default payload
    let payload = { id, values }

    // Activity / Arc: backend expects { id, values }
    if (ACTIVITY_FILTERS.includes(id) || ACTIVITY_FILTERS.includes(kind)) {
        payload = { id, values }
    }
    if (ARC_FILTERS.includes(id) || ARC_FILTERS.includes(kind)) {
        payload = { id, values }
    }

    // Dates: backend expects ISO-like string
    if (DATE_FILTERS.includes(id) || DATE_FILTERS.includes(kind)) {
        const first = values[0]
        const formatted = formatDateToBackend(first)
        payload = { id, values: formatted ? [formatted] : [] }
        const activity = unwrapValue(meta.activity || filter.activity || (filter.type || {}).category)
        if (activity) payload.activity = activity
    }

    // Durations: values should already be backend-ready in most cases (ISO duration or array for ACTIVITIES_*)
    if (DURATION_FILTERS.includes(id) || DURATION_FILTERS.includes(kind)) {
        payload = { id, values }
        const activity = unwrapValue(meta.activity || filter.activity || (filter.type || {}).category)
        const arc = unwrapValue(meta.arc || filter.arc || (filter.type || {}).arc)
        if (activity) payload.activity = activity
        if (arc) payload.arc = arc
    }

    // Attributes: backend expects { id: constraintId, attribute, values, (optional) activity }
    // Note: filter sets may provide attribute filters without `kind`, so detect by id prefix too.
    if (ATTRIBUTES_FILTERS.includes(kind) || ATTRIBUTES_FILTERS.includes(id) || /^TRACE_ATTRIBUTES_(CTG|BOOL|NUM|DATE)_/.test(id || '')) {
        const attribute = unwrapValue(meta.attribute || filter.attribute)
        const activity = unwrapValue(meta.activity || filter.activity)

        // Attribute date constraints need formatting
        let formattedValues = values
        if (id === 'TRACE_ATTRIBUTES_DATE_BETWEEN') {
            formattedValues = values.map(formatDateToBackend).filter(Boolean)
        } else if (id === 'TRACE_ATTRIBUTES_DATE_AFTER' || id === 'TRACE_ATTRIBUTES_DATE_BEFORE') {
            const formatted = formatDateToBackend(values[0])
            formattedValues = formatted ? [formatted] : []
        }

        payload = {
            id,
            attribute,
            values: formattedValues,
        }
        if (activity && activity !== '*') payload.activity = activity
    }

    // Variants/Loops/NVariants/Traces: backend expects {id, values}
    if (VARIANT_FILTERS.includes(id) || VARIANT_FILTERS.includes(kind)) {
        payload = { id, values }
    }
    if (LOOP_FILTERS.includes(id) || LOOP_FILTERS.includes(kind)) {
        payload = { id, values }
    }
    if (NVARIANTS_FILTERS.includes(id) || NVARIANTS_FILTERS.includes(kind)) {
        payload = { id, values }
    }
    if (TRACES_FILTERS.includes(id)) {
        payload = { id, values }
    }

    return payload
}

export function serializeFiltersForApi(filters = []) {
    return (filters || [])
        .map(serializeFilterForApi)
        .filter(Boolean)
}
